import React from 'react';
import { FaInstagram, FaFacebook, FaYoutube, FaTwitter,FaLinkedinIn , FaMapMarkerAlt, FaPhone, FaEnvelope, FaHeart } from 'react-icons/fa';
import FooterLogo from '/logo-black.png';

const Footer = () => {
  return (
    <>
     <div id='Footer'>
      <div className='container'>
    <div className='FooterMain'>
        <div className='FooterTop'>
          <div className='FooterLogo'>
            <img src={FooterLogo} alt="Yogify Logo" />
          </div>
          <div className='FooterAboutLinks'>
            <div className='FooterAboutBox'>
              <div className='FooterAbout'>
                <h2>About Us</h2>
                <p>Fuel your fitness with premium protein supplements designed for real performance. Our products support lean muscle growth, strength, and fast recovery</p>
              </div>
              <div className='socialLinks'>
                <a href="https://www.instagram.com/xkeiwellness/" target="_blank" rel="noopener noreferrer">
                  <FaInstagram />
                </a>
                <a href="https://www.facebook.com/share/16smNJX8C6/" target="_blank" rel="noopener noreferrer">
                  <FaFacebook />
                </a>
                <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
                  <FaLinkedinIn  />
                </a>
                {/* <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                  <FaTwitter />
                </a> */}
              </div>
            </div>
            <div className='FooterLinks'>
              <h2>Quick Links</h2>
              <ul>
                <li><a href="/">Home</a></li>
                <li><a href="/product">Products</a></li>
                {/* <li><a href="/workshops">Workshops</a></li> */}
              </ul>
            </div>
            {/* <div className='FooterLinks'>
              <h2>Discover</h2>
              <ul>
                <li><a href="/about">About</a></li>
                <li><a href="/blogs">Blogs</a></li>
                <li><a href="/gallery">Gallery</a></li>
              </ul>
            </div> */}
            <div className='FooterContact'>
              <h2>Contact Us</h2>
              <ul>
                <li>
                  <FaMapMarkerAlt />
                  <a href="https://maps.google.com" target="_blank" rel="noopener noreferrer">
                     Karukutty, Angamaly, <br/>Ernakulam, Kerala 683576
                  </a>
                </li>
                <li>
                  <FaPhone />
                  <a href="tel:+918589833066">+91 8589833066</a>
                </li>
                <li>
                  <FaEnvelope />
                  <a href="mailto:letusknow.xkeiwellness@gmail.com">letusknow.xkeiwellness@gmail.com</a>
                </li>
              </ul>
            </div>
          </div>
        </div>      
      </div>
      </div>
    </div>
      <div className='FooterBottom'>
        <div className='container'>
          <div className='FooterBottomMain'>
          <div className='Copyright'>
            <p>Copyright © Xwellness All right reserved.</p>
          </div>
          {/* <div className='TermsCondition'>
            <a href="/termsandconditions">Terms and conditions</a>
            <a href="/privacypolicy">Privacy Policy</a>
            <a href="/faq">FAQ</a>
          </div> */}
          <div className='Designwith'>
            <p>Design With <FaHeart />VATL</p>
          </div>
          </div>
        </div>
        </div>
    </>
   
  );
};

export default Footer;